var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticClass:"preview-modal",attrs:{"title":_vm.title,"footer":null,"width":840},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('AiScoreViewDetail',{attrs:{"ai-score":_vm.record}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }